import { render } from "./Bild.vue?vue&type=template&id=98008d86&scoped=true"
import script from "./Bild.vue?vue&type=script&lang=js"
export * from "./Bild.vue?vue&type=script&lang=js"

import "./Bild.vue?vue&type=style&index=0&id=98008d86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98008d86"]])

export default __exports__